import styled from 'styled-components'
import variablesApplicationConfig from '../../../../variables'

const ContainerSectionContactCircular = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;

  margin-top: 50px;

  .middle-section {
    width: 100%;
    max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px;

    margin-top: 80px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 70px;

    .m-s-left {
      width: 100%;
      max-width: 600px;
      .box-form {
        width: 100%;

        background-color: white;

        border-radius: 20px;

        padding: 40px;

        display: flex;
        flex-direction: column;

        gap: 20px;

        .double-input {
          width: 100%;

          display: flex;
          flex-wrap: nowrap;
          flex-direction: row;

          gap: 30px;
        }

        .box-input-global {
          width: 100%;

          position: relative;

          .box-input-label {
            margin-bottom: 5px;
            line-height: 30px;
          }

          input {
            width: 100%;
            height: 60px;

            border-radius: 60px;

            padding: 0px 60px 0px 20px;

            font-size: 18px;

            border: 1px solid #e3dbd8;

            &::placeholder {
              color: #727272;
            }
          }

          textarea {
            width: 100%;
            height: 120px;

            border-radius: 20px;

            padding: 20px 20px;

            font-size: 18px;

            border: 1px solid #e3dbd8;

            resize: none;

            &::placeholder {
              color: #727272;
            }
          }

          .box-input-icon-float {
            position: absolute;

            bottom: 16px;
            right: 26px;

            &.textarea {
              top: 56px;
              bottom: auto;
            }

            svg {
              font-size: 20px;
              color: ${(props) =>
                props.color
                  ? 'var(--primary-color)'
                  : 'var(--secondary-color)'};
            }
          }
        }

        .form-button {
          background-color: var(--primary-color);

          color: white;

          display: flex;
          align-items: center;
          justify-content: center;

          height: 60px;

          border-radius: 60px;

          font-weight: 600;

          cursor: pointer;
        }
      }
    }

    .m-s-right {
      margin-left: 80px;

      color: ${(props) =>
        props.color ? 'var(--primary-color)' : 'var(--secondary-color)'};

      .m-s-r-label {
        font-weight: 700;
        font-size: 18px;
        font-family: var(--secondary-font-family);

        display: flex;
        align-items: center;

        svg {
          width: 50px !important;
          margin-top: 6px;
          margin-left: 10px;
        }
      }
      .m-s-r-title {
        font-size: 50px;
        line-height: 60px;
        font-weight: bold;
        margin-top: 10px;
        transition: all 0.6s ease-in-out;
        color: black;
      }

      .m-s-r-description {
        color: #727272;
        font-size: 16px;
        line-height: 30px;
        margin-top: 20px;

        margin-bottom: 20px;
      }

      .m-s-r-box-location {
        display: flex;
        width: 100%;
        flex-direction: column;

        .m-s-r-location-item {
          width: 100%;
          display: flex;
          margin-bottom: 20px;

          .m-s-r-location-icon-left {
            width: 65px;
            height: 65px;

            display: flex;
            align-items: center;
            justify-content: flex-start;

            font-size: 25px;
            color: var(--primary-color);
          }
          .m-s-r-location-data-right {
            .title {
              color: #727272;
              font-size: 16px;
              line-height: 30px;
              margin-bottom: 3px;
            }
            .data {
              color: ${(props) =>
                props.color
                  ? 'var(--primary-color)'
                  : 'var(--secondary-color)'};
              font-size: 18px;
              line-height: 30px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px) {
    .middle-section {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.tabletBreakpoint}px) {
    .middle-section {
      flex-direction: column;
      gap: 50px;
      .m-s-left {
        .box-form {
          padding: 20px;
          .double-input {
            flex-direction: column !important;
            gap: 20px !important;
          }
        }
      }
      .m-s-right {
        width: 100%;
        max-width: 600px;
        margin-left: 0 !important;
        .m-s-r-title {
          max-width: 100% !important;
          font-size: 30px !important;
          line-height: 40px !important;
        }
      }
    }
  }
`

export default ContainerSectionContactCircular
